





























































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import CardTile from '@/views/browse-and-go/components/CardTile.vue'
import { audienceLabel, formatDuration } from '@/services/browse-and-go/labels'
import { bngState } from '@/services/browse-and-go/store'

@Component({
  name: 'BrowseAndGoUrssaf',
  components: { PageHeader, CardTile }
})
export default class extends Vue {
  private activeId = ''

  get urssafOperations() {
    return bngState.operations.filter(operation => operation.family === 'URSSAF')
  }

  get activeOperation() {
    return this.urssafOperations.find(operation => operation.id === this.activeId) || this.urssafOperations[0] || null
  }

  get activeCards() {
    if (!this.activeOperation) return []
    return bngState.cards.filter(card => card.operationModelId === this.activeOperation.id)
  }

  get duration() {
    return this.activeOperation ? formatDuration(this.activeOperation.defaultDurationMonths) : ''
  }

  get audience() {
    return this.activeOperation ? audienceLabel(this.activeOperation.defaultAudience) : ''
  }

  @Watch('urssafOperations', { immediate: true })
  private ensureActive() {
    if (!this.urssafOperations.some(operation => operation.id === this.activeId)) {
      this.activeId = this.urssafOperations[0] ? this.urssafOperations[0].id : ''
    }
  }

  private editOperation() {
    if (!this.activeOperation) return
    this.$router.push({ name: 'BrowseAndGoUrssafOperationEdit', params: { id: this.activeOperation.id } })
  }

  private createCard() {
    if (!this.activeOperation) return
    this.$router.push({
      name: 'BrowseAndGoCardCreate',
      query: { operationId: this.activeOperation.id, from: 'urssaf' }
    })
  }

  private editCard(id: string) {
    this.$router.push({ name: 'BrowseAndGoCardEdit', params: { id }, query: { from: 'urssaf' } })
  }

  private cloneCard(id: string) {
    this.$router.push({ name: 'BrowseAndGoCardCreate', query: { cloneFrom: id, from: 'urssaf' } })
  }
}
